import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/toaster";
import { AuthProvider } from "./context/AuthContext";
import ScrollToTop from "./components/ScrollToTop";
import Header from "./components/Header";
import Footer from "./components/Footer";
import AICounsellor from "./components/AICounsellor";
import Home from "./pages/Home";
import Destinations from "./pages/Destinations";
import DestinationDetail from "./pages/DestinationDetail";
import Universities from "./pages/Universities";
import UniversityDetail from "./pages/UniversityDetail";
import Services from "./pages/Services";
import OSSD from "./pages/OSSD";
import OdlCourses from "./pages/OdlCourses";
import Verify from "./pages/Verify";
import TestPrep from "./pages/TestPrep";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";

// Admin
import AdminLogin from "./admin/AdminLogin";
import AdminLayout from "./admin/AdminLayout";
import Dashboard from "./admin/Dashboard";
import Leads from "./admin/Leads";
import Analytics from "./admin/Analytics";
import InternalChat from "./admin/InternalChat";
import AILogs from "./admin/AILogs";
import Applications from "./admin/Applications";
import AdminUniversities from "./admin/Universities";
import AdminOffices from "./admin/Offices";
import AdminInstitutions from "./admin/Institutions";
import AdminSchools from "./admin/Schools";
import AdminActivityLog from "./admin/ActivityLog";
import InstallPWA from "./components/InstallPWA";
import Books from "./admin/Books";
import Settings from "./admin/Settings";
import Approvals from "./admin/Approvals";
import MasterPage from "./admin/MasterPage";
import StudentPortal from "./portal/StudentPortal";
import TeacherPortal from "./portal/TeacherPortal";
import AgentPortal from "./portal/AgentPortal";
import ParentPortal from "./portal/ParentPortal";
import { captureUtm } from "./lib/utm";

function PublicSite() {
  React.useEffect(() => { captureUtm(); }, []);
  return (
    <>
      <Header />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/destinations" element={<Destinations />} />
          <Route path="/destinations/:slug" element={<DestinationDetail />} />
          <Route path="/universities" element={<Universities />} />
          <Route path="/universities/:slug" element={<UniversityDetail />} />
          <Route path="/services" element={<Services />} />
          <Route path="/ossd" element={<OSSD />} />
          <Route path="/odl-courses" element={<OdlCourses />} />
          <Route path="/verify" element={<Verify />} />
          <Route path="/test-prep" element={<TestPrep />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
        </Routes>
      </main>
      <Footer />
      <AICounsellor />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            {/* Admin */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<Dashboard />} />
              <Route path="leads" element={<Leads />} />
              <Route path="analytics" element={<Analytics />} />
              <Route path="applications" element={<Applications />} />
              <Route path="books" element={<Books />} />
              <Route path="settings" element={<Settings />} />
              <Route path="approvals" element={<Approvals />} />
              <Route path="chat" element={<InternalChat />} />
              <Route path="ai-logs" element={<AILogs />} />
              <Route path="countries" element={<MasterPage entity="countries" />} />
              <Route path="companies" element={<MasterPage entity="companies" />} />
              <Route path="offices" element={<AdminOffices />} />
              <Route path="roles" element={<MasterPage entity="roles" />} />
              <Route path="designations" element={<MasterPage entity="designations" />} />
              <Route path="employees" element={<MasterPage entity="employees" />} />
              <Route path="agents" element={<MasterPage entity="agents" />} />
              <Route path="teachers" element={<MasterPage entity="teachers" />} />
              <Route path="students" element={<MasterPage entity="students" />} />
              <Route path="edu-courses" element={<MasterPage entity="edu_courses" />} />
              <Route path="streams" element={<MasterPage entity="streams" />} />
              <Route path="fields" element={<MasterPage entity="fields" />} />
              <Route path="institutions" element={<AdminInstitutions />} />
              <Route path="schools" element={<AdminSchools />} />
              <Route path="activity" element={<AdminActivityLog />} />
              <Route path="previous-schools" element={<MasterPage entity="institutions" />} />
              <Route path="universities" element={<AdminUniversities />} />
              <Route path="odl-courses" element={<MasterPage entity="odl_courses" />} />
              <Route path="certificates" element={<MasterPage entity="certificates" />} />
              <Route path="fee-master" element={<MasterPage entity="fee_master" />} />
              <Route path="parents" element={<MasterPage entity="parents" />} />
              <Route path="guardians" element={<MasterPage entity="guardians" />} />
              <Route path="guardian-relations" element={<MasterPage entity="guardian_relations" />} />
              <Route path="currencies" element={<MasterPage entity="currencies" />} />
              <Route path="testimonials" element={<MasterPage entity="testimonials" />} />
            </Route>

            {/* Student, Teacher, Agent & Parent portals */}
            <Route path="/portal/student" element={<StudentPortal />} />
            <Route path="/portal/teacher" element={<TeacherPortal />} />
            <Route path="/portal/agent" element={<AgentPortal />} />
            <Route path="/portal/parent" element={<ParentPortal />} />

            {/* Public site */}
            <Route path="/*" element={<PublicSite />} />
          </Routes>
          <Toaster />
          <InstallPWA />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
